// ES UI catalogue.
// __I18N_PENDING__: values are not yet translated and fall back to English at runtime.
export default {
  'site.header.apartments': 'Apartamentos y hoteles',
  'site.currency': 'Moneda',
  'site.language': 'Idioma',
  'site.currencySelector': 'Selector de moneda',
  'site.languageSelector': 'Selector de idioma',
  'site.menu': 'Menú',
  'site.signIn': 'Iniciar sesión',
  'site.signOut': 'Cerrar sesión',
  'site.signOutConfirmTitle': '__I18N_PENDING__:Sign out?',
  'site.signOutConfirmBody': '__I18N_PENDING__:Are you sure you want to sign out?',
  'site.signOutStay': '__I18N_PENDING__:Stay signed in',
  'site.openMenu': 'Abrir menú',
  'site.footer.copyright': 'Todos los derechos reservados.',
  'site.footer.manageBooking': 'Gestionar tu reserva',
  'site.footer.terms': 'Términos y condiciones',
  'site.footer.privacy': 'Política de privacidad',
  'site.trust.bestPrice': 'Mejor precio garantizado',
  'site.trust.bestPriceDesc': 'Obtén las mejores tarifas.',
  'site.trust.flexibleBooking': 'Reserva flexible',
  'site.trust.flexibleBookingDesc': 'Cambios y cancelaciones sencillas.',
  'site.trust.securePayments': 'Pagos seguros',
  'site.trust.securePaymentsDesc': 'Pago de confianza y seguro.',
  'site.trust.localSupport': 'Atención local',
  'site.trust.localSupportDesc': 'Estamos aquí para ayudarte cuando lo necesites.',
  'home.heroTitle': 'Encuentra tu estancia ideal',
  'home.inAustralia': 'en Australia',
  'home.heroSubtitle': 'Apartamentos y hoteles para cada tipo de estancia',
  'home.errorLoading': 'No se pudieron cargar los alojamientos.',
  'home.noPropertiesTitle': 'No hay alojamientos disponibles ahora mismo.',
  'home.noPropertiesDescription': 'Intenta buscar un destino para explorar estancias disponibles.',
  'home.exploreStays': 'Explorar estancias',
  'home.property': 'propiedad',
  'home.property_one': 'propiedad',
  'home.property_other': 'propiedades',
  'home.properties': 'propiedades',
  'home.foundInAustralia': 'encontrado en Australia',
  'search.errorLoading': 'No se pudo cargar la disponibilidad. Inténtalo de nuevo.',
  'search.noResults': 'Ninguna propiedad coincide con tus criterios de búsqueda.',
  'search.mapFollow': 'Buscar al mover el mapa',
  'search.chooseLocationTitle': 'Elige una ubicación',
  'search.chooseLocationDescription':
    'Selecciona un destino antes de buscar estancias disponibles.',
  'search.chooseDatesTitle': 'Elige tus fechas',
  'search.pastCheckIn': 'El check-in no puede ser en el pasado.',
  'search.checkOutAfterCheckIn': 'El check-out debe ser posterior al check-in.',
  'search.property': 'propiedad',
  'search.property_one': 'propiedad',
  'search.property_other': 'propiedades',
  'search.properties': 'propiedades',
  'search.found': 'encontrado',
  'widget.where': '¿Dónde?',
  'widget.location': 'Ubicación',
  'widget.checkInOut': 'Entrada / Salida',
  'widget.guests': 'Huéspedes',
  'widget.rooms': 'Habitaciones',
  'widget.promoCode': 'Código promocional',
  'widget.promoPlaceholderCompact': 'Agregar código (opcional)',
  'widget.promoPlaceholder': 'Opcional',
  'widget.search': 'Buscar',
  'widget.update': '__I18N_PENDING__:Update',
  'widget.adult': 'Adulto',
  'widget.adults': 'Adultos',
  'widget.child': 'Niño',
  'widget.children': 'Niños',
  'widget.decreaseAdults': 'Reducir adultos',
  'widget.increaseAdults': 'Aumentar adultos',
  'widget.decreaseChildren': 'Reducir niños',
  'widget.increaseChildren': 'Aumentar niños',
  'widget.room': 'Habitación',
  'widget.adultOption': '{count} adultos',
  'widget.adultOption_one': '{count} adulto',
  'widget.adultOption_other': '{count} adultos',
  'widget.childOption': '{count} niños',
  'widget.childOption_one': '{count} niño',
  'widget.childOption_other': '{count} niños',
  'widget.roomOption': '{count} habitaciones',
  'widget.roomOption_one': '{count} habitación',
  'widget.roomOption_other': '{count} habitaciones',
  'widget.guestCount': '__I18N_PENDING__:{count} guests',
  'widget.guestCount_one': '__I18N_PENDING__:{count} guest',
  'widget.guestCount_other': '__I18N_PENDING__:{count} guests',
  'widget.roomCount': '__I18N_PENDING__:{count} rooms',
  'widget.roomCount_one': '__I18N_PENDING__:{count} room',
  'widget.roomCount_other': '__I18N_PENDING__:{count} rooms',
  'widget.locationError': 'No se pudieron cargar las ubicaciones. Inténtalo de nuevo.',
  'widget.searchAria': 'Buscar disponibilidad',
  'widget.dateErrorRequired': 'Selecciona las fechas de entrada y salida.',
  'widget.dateErrorPast': 'El check-in no puede ser en el pasado.',
  'widget.dateErrorRange': 'El check-out debe ser posterior al check-in.',
  'widget.dateRange.placeholder': 'Selecciona las fechas de entrada y salida',
  'widget.dateRange.selectCheckout': 'Seleccionar salida',
  'widget.dateRange.aria.checkIn': 'Check-in',
  'widget.dateRange.aria.checkOut': 'Check-out',
  'widget.dateRange.aria.picker': 'Selector de rango de fechas de entrada y salida',
  'widget.dateRange.previousMonth': 'Mes anterior',
  'widget.dateRange.nextMonth': 'Mes siguiente',
  'widget.dateRange.selectCheckIn': 'Seleccionar fecha de entrada',
  'widget.dateRange.selectCheckOut': 'Seleccionar fecha de salida',
  'widget.dateRange.resetToday': 'Restablecer a hoy',
  'widget.dateRange.done': 'Hecho',
  'property.heroAlt': 'Imagen principal de la propiedad',
  'property.fallbackName': 'Propiedad seleccionada por {site}',
  'property.chooseRoom': 'Elige tu habitación',
  'property.filterBy': 'Filtrar por:',
  'property.filterAll': 'Todas las habitaciones',
  'property.filterStudios': 'Estudios',
  'property.filter1Bed': '1 dormitorio',
  'property.filter2Bed': '2 dormitorios',
  'property.filterApartments': 'Apartamentos',
  'property.sortBy': 'Ordenar por:',
  'property.sortRecommended': 'Recomendado',
  'property.sortPriceLow': 'Precio: de menor a mayor',
  'property.sortPriceHigh': 'Precio: de mayor a menor',
  'property.errorLoading': 'No se pudo cargar la disponibilidad. Inténtalo de nuevo.',
  'property.noRooms': 'No hay habitaciones disponibles',
  'property.noRoomsDescription': 'Prueba con otras fechas u ocupación.',
  'property.totalForNights': 'Total por {nights} noches',
  'property.perNight': 'por noche',
  'property.night': 'noche',
  'property.night_one': 'noche',
  'property.night_other': 'noches',
  'property.nights': 'noches',
  'property.freeCancellation': 'Cancelación gratuita',
  'property.selectRoom': 'Seleccionar habitación',
  'property.selected': 'Seleccionada',
  'property.continue': 'Continuar',
  'property.previousPhoto': 'Foto anterior',
  'property.nextPhoto': 'Foto siguiente',
  'property.addToWishlist': 'Agregar a favoritos',
  'property.popularChoice': 'Opción popular',
  'property.showMore': 'Mostrar más',
  'property.showLess': 'Mostrar menos',
  'property.maxOccupancy': 'Ocupación máxima:',
  'property.size': 'Tamaño:',
  'property.bedType': 'Tipo de cama:',
  'property.roomAmenities': 'Servicios de la habitación',
  'property.showMoreAmenities': '+{count} más',
  'property.guests': 'Huéspedes',
  'property.adults': 'Adultos',
  'property.children': 'Niños',
  'property.onlyRoomsLeft': 'Solo quedan {count} habitaciones',
  'property.onlyRoomsLeft_one': 'Solo queda {count} habitación',
  'property.onlyRoomsLeft_other': 'Solo quedan {count} habitaciones',
  'property.lastBookedMinutes': 'Última reserva hace {count} minutos',
  'property.lastBookedMinutes_one': 'Última reserva hace {count} minuto',
  'property.lastBookedMinutes_other': 'Última reserva hace {count} minutos',
  'property.lastBookedHours': 'Última reserva hace {count} horas',
  'property.lastBookedHours_one': 'Última reserva hace {count} hora',
  'property.lastBookedHours_other': 'Última reserva hace {count} horas',
  'property.lastBookedDays': 'Última reserva hace {count} días',
  'property.lastBookedDays_one': 'Última reserva hace {count} día',
  'property.lastBookedDays_other': 'Última reserva hace {count} días',
  'property.checkInTime': 'Check-in {time}',
  'property.checkOutTime': 'Check-out {time}',
  'property.compare': 'Comparar',
  'property.taxesIncluded': 'por noche, impuestos y tarifas incluidos',
  'property.chooseRate': 'Elige tu tarifa',
  'property.yourSelection': 'Tu selección',
  'property.aboutRoom': 'Sobre esta habitación',
  'property.roomDetails': 'Detalles de la habitación',
  'property.selectedProperty': '__I18N_PENDING__:Selected property by {site}',
  'property.backToRooms': 'Volver a habitaciones',
  'property.standardRate': 'Tarifa estándar',
  'property.noPromotion': 'No hay promociones disponibles para esta tarifa.',
  'property.youSave': 'Ahorras ({percent}% de descuento) - {amount}',
  'property.inclusions': 'Incluye:',
  'property.viewAllPhotos': 'Ver todas las fotos',
  'property.seeOnMap': 'Ver en el mapa',
  'room.perNight': 'noche',
  'room.sleeps': 'Capacidad',
  'room.thumbnailAlt': '__I18N_PENDING__:Thumbnail',
  'room.available': 'disponible',
  'room.select': 'Seleccionar',
  'room.selected': 'Seleccionada',
  'card.viewAvailability': 'Ver disponibilidad',
  'card.from': 'Desde',
  'card.night': 'noche',
  'card.checkAvailability': 'Ver disponibilidad',
  'card.saveToFavourites': 'Guardar en favoritos',
  'card.ratingExcellent': 'Excelente',
  'card.ratingVeryGood': 'Muy bueno',
  'card.ratingGood': 'Bueno',
  'card.ratingGuest': 'Valoración de huéspedes',
  'guest.stepChooseRoom': 'Elegir habitación',
  'guest.stepGuestDetails': 'Datos del huésped',
  'guest.stepPayment': 'Pago',
  'guest.stepConfirmation': 'Confirmación',
  'guest.title': 'Ingresa los datos del huésped',
  'guest.subtitle': 'Por favor, proporciona tu información.',
  'guest.firstName': 'Nombre',
  'guest.lastName': 'Apellido',
  'guest.email': 'Correo electrónico',
  'guest.emailHint': 'La confirmación de la reserva se enviará a este correo.',
  'guest.country': 'País',
  'guest.selectCountry': 'Seleccionar país',
  'guest.searchCountry': 'Buscar países…',
  'guest.loadingCountries': 'Cargando países…',
  'guest.loadingSuburbs': '__I18N_PENDING__:Loading suburbs…',
  'guest.noSuburbsFound': '__I18N_PENDING__:No suburbs found',
  'guest.selectedSuburb': '__I18N_PENDING__:Selected: {suburb}',
  'guest.postalCode': 'Código postal',
  'guest.phone': 'Teléfono',
  'guest.phoneCountryCode': '__I18N_PENDING__:Country code',
  'guest.phonePlaceholder': 'Ingresa tu número de teléfono',
  'guest.address': 'Dirección',
  'guest.city': 'Ciudad',
  'guest.specialRequests': 'Solicitudes especiales (opcional)',
  'guest.specialRequestsPlaceholder': '¿Alguna solicitud especial?',
  'guest.termsPrefix': 'Al completar esta reserva, acepto los',
  'guest.terms': 'Términos y condiciones',
  'guest.termsAnd': 'y la',
  'guest.privacy': 'Política de privacidad',
  'guest.termsSuffix': ', y acepto las condiciones de la reserva.',
  'guest.marketingOptOut': 'No quiero recibir mensajes de marketing.',
  'guest.cardVerify':
    'Se realizará una verificación temporal de 1 {currency} en tu tarjeta. No se te cobrará ahora.',
  'guest.chargeNow': '__I18N_PENDING__:Your card will be charged {amount} now.',
  'guest.payOnArrival': 'El pago se recogerá en el alojamiento.',
  'guest.noRoomsSelected': 'No se han seleccionado habitaciones.',
  'guest.noPropertySelected': 'No se ha seleccionado ninguna propiedad.',
  'guest.paymentStillLoading':
    'Las opciones de pago aún se están cargando. Inténtalo de nuevo en un momento.',
  'guest.submitProcessing': 'Procesando…',
  'guest.submitVerifyCard': 'Verificar tarjeta y confirmar reserva',
  'guest.submitConfirm': 'Confirmar reserva',
  'checkout.backToRooms': '__I18N_PENDING__:Back to room selection',
  'checkout.bookingSummary': '__I18N_PENDING__:Your booking summary',
  'checkout.noRooms': '__I18N_PENDING__:No rooms in this booking — add one below.',
  'checkout.edit': '__I18N_PENDING__:Edit',
  'checkout.remove': '__I18N_PENDING__:Remove',
  'checkout.removeTitle': '__I18N_PENDING__:Remove this room?',
  'checkout.removeBody':
    "__I18N_PENDING__:{room} will be removed from your booking. This action can't be undone — you'll need to select the room again to add it back.",
  'checkout.removeCancel': '__I18N_PENDING__:Cancel',
  'checkout.removeConfirm': '__I18N_PENDING__:Remove room',
  'checkout.duration': '__I18N_PENDING__:Duration of stay',
  'checkout.occupancy': '__I18N_PENDING__:Occupancy',
  'checkout.occupancyValue': '__I18N_PENDING__:{adults} Adults, {children} Children',
  'checkout.ratePlan': '__I18N_PENDING__:Rate Plan',
  'checkout.policies': '__I18N_PENDING__:Cancellation & Payment Policies',
  'checkout.roomRequests': '__I18N_PENDING__:Special requests (optional)',
  'checkout.roomRequestsPlaceholder':
    '__I18N_PENDING__:Arrival time, accessibility needs or anything else for this room',
  'checkout.roomSubTotal': '__I18N_PENDING__:Sub Total',
  'checkout.accommodationFees':
    '__I18N_PENDING__:Accommodation fees • {rooms} room(s) · {nights} nights',
  'checkout.taxesAndFees': '__I18N_PENDING__:Taxes & fees',
  'checkout.memberSavings': '__I18N_PENDING__:Member savings',
  'checkout.promotionSavings': '__I18N_PENDING__:Savings',
  'checkout.total': '__I18N_PENDING__:Total',
  'checkout.totalCaption': '__I18N_PENDING__:Includes taxes & fees',
  'checkout.propertyCurrencyTitle':
    '__I18N_PENDING__:Estimated total in property currency ({currency})',
  'checkout.propertyCurrencyNote':
    "__I18N_PENDING__:Prices are shown in {currency} for your convenience, converted at today's exchange rate. Your payment will be processed in the property's currency ({propertyCurrency}), so the final amount on your statement may vary slightly with exchange-rate movements on the day of payment.",
  'checkout.addAnotherRoom': '__I18N_PENDING__:Add another room',
  'checkout.memberTitle': '__I18N_PENDING__:Join as a member now — membership is free',
  'checkout.memberTitleWithSaving':
    '__I18N_PENDING__:Join as a member now — save {amount} on this booking',
  'checkout.memberBody': '__I18N_PENDING__:Member discounts apply before you pay.',
  'checkout.memberJoin': '__I18N_PENDING__:Join free',
  'checkout.memberSignIn': '__I18N_PENDING__:Sign in',
  'checkout.memberJoinInline': '__I18N_PENDING__:Join as a member using the details above',
  'checkout.memberJoinInlineHint':
    '__I18N_PENDING__:Get access to exclusive member benefits and offers.',
  'checkout.memberTotal': '__I18N_PENDING__:Member total',
  'checkout.memberSaveCaption': '__I18N_PENDING__:You save {amount} · includes taxes & fees',
  'checkout.nonMemberTotalCaption': '__I18N_PENDING__:Non-member total · includes taxes & fees',
  'checkout.stayConnected':
    '__I18N_PENDING__:Stay connected with {site} — get exclusive offers, deals and newsletters. Opt out anytime.',
  'checkout.proceedToPayment': '__I18N_PENDING__:Proceed to payment',
  'checkout.processing': '__I18N_PENDING__:Processing your booking…',
  'checkout.processingDoNotClose':
    '__I18N_PENDING__:Processing your booking — please do not close this window until your booking is confirmed.',
  'checkout.doNotClose':
    '__I18N_PENDING__:Please do not close your browser until your booking is confirmed.',
  'checkout.applyingMemberRates': '__I18N_PENDING__:Applying member rates to your stay…',
  'checkout.loadingProfile': '__I18N_PENDING__:Loading your member details…',
  'checkout.preparingPayment': '__I18N_PENDING__:Preparing secure payment…',
  'checkout.termsHint':
    '__I18N_PENDING__:The button becomes active once you accept the Terms & Conditions.',
  'checkout.gatewayRedirect':
    "__I18N_PENDING__:You'll be redirected to {gateway}, our secure payment provider, to complete your booking.",
  'checkout.securePayment':
    '__I18N_PENDING__:Your payment is handled by our secure payment provider.',
  'checkout.stayDates': '__I18N_PENDING__:{checkIn} – {checkOut} • {nights} nights',
  'payment.title': 'Pago',
  'payment.method': 'Método de pago',
  'payment.cardDetailsHint':
    'Ingresa los datos de tu tarjeta de forma segura a continuación. Los datos de tu tarjeta se tokenizan y nunca llegan a nuestros servidores.',
  'payment.loadingForm': 'Cargando formulario de pago…',
  'payment.formUnavailable': 'Formulario de pago no disponible.',
  'payment.acceptTerms': 'Acepto los términos y condiciones y la política de cancelación.',
  'payment.payNow': 'Pagar ahora',
  'payment.processing': 'Procesando…',
  'payment.noRoomsSelected': 'No se han seleccionado habitaciones.',
  'payment.redirecting': 'Redirigiendo a la página de pago seguro…',
  'payment.notConfigured': 'Quickstream no está configurado para esta propiedad.',
  'payment.noScript':
    'No se pudo cargar el servicio de pago de Quickstream. Por favor, actualiza la página.',
  'payment.formNotLoaded': 'El formulario de pago no se cargó. Por favor, actualiza la página.',
  'payment.cardDetails': 'El pago falló. Por favor, revisa los datos de tu tarjeta.',
  'payment.tokenizationFailed': 'La tokenización de la tarjeta falló. Inténtalo de nuevo.',
  'payment.failed': 'El pago falló.',
  'payment.statusResult': 'Estado del pago: {status}. Inténtalo de nuevo.',
  'confirmation.loading': 'Cargando tu reserva…',
  'confirmation.notFound': 'Reserva no encontrada. Revisa tu referencia e inténtalo de nuevo.',
  'confirmation.errorGeneric':
    'No se pudo confirmar tu reserva. Ponte en contacto con atención al cliente.',
  'confirmation.errorLoadDetails': 'No se pudieron cargar los detalles de la reserva.',
  'confirmation.couldNotComplete': 'No pudimos completar tu pago',
  'confirmation.startNew': 'Iniciar una nueva reserva',
  'confirmation.tryPaymentAgain': '__I18N_PENDING__:Try payment again',
  'confirmation.paymentNotFound':
    'No se encontró la sesión de pago. Ponte en contacto con atención al cliente.',
  'confirmation.paymentStateInvalid':
    'El pago no está en un estado válido para completarse. Por favor, empieza de nuevo.',
  'confirmation.paymentFailedDeclined':
    'No se pudo completar tu pago. Por favor, revisa los datos de tu tarjeta e inténtalo de nuevo, o usa otro método de pago.',
  'confirmation.paymentTimeout': 'El pago tardó demasiado. Inténtalo de nuevo.',
  'confirmation.paymentGatewayUnavailable':
    'El sistema de pagos no está disponible temporalmente. Inténtalo de nuevo en unos momentos.',
  'confirmation.paymentUnknown': 'No se pudo confirmar el pago: {message}.',
  'confirmation.paymentGenericError':
    'No se pudo confirmar el pago. Inténtalo de nuevo o ponte en contacto con atención al cliente.',
  'summary.title': 'Resumen de tu reserva',
  'summary.yourBooking': 'Resumen de tu reserva',
  'summary.noRoomsSelected': 'Aún no has seleccionado habitaciones.',
  'summary.checkIn': 'ENTRADA',
  'summary.checkOut': 'SALIDA',
  'summary.lengthOfStay': 'Duración de la estancia',
  'summary.guests': 'Huéspedes',
  'summary.nights': '{nights} noches',
  'summary.nights_one': '{nights} noche',
  'summary.nights_other': '{nights} noches',
  'summary.totalForNights': 'Total por {nights} noches',
  'summary.includingTaxes': 'Incluidos impuestos y tarifas',
  'summary.discount': 'Ahorra {amount}',
  'summary.checkInFrom': '__I18N_PENDING__:From {time}',
  'summary.checkOutUntil': '__I18N_PENDING__:Until {time}',
  'summary.cancellationUntil': '__I18N_PENDING__:until {date}',
  'detail.confirmed': '¡Reserva confirmada!',
  'detail.received': 'Reserva recibida',
  'detail.referenceIntro': 'Tu referencia de reserva es',
  'detail.reservationId': 'ID de reserva:',
  'detail.processing':
    'Tu reserva se está procesando. Recibirás un correo de confirmación una vez que se confirme el pago.',
  'detail.guest': 'Huésped',
  'detail.rooms': 'Habitaciones',
  'detail.night': 'noche',
  'detail.nights': 'noches',
  'detail.adult': 'adulto',
  'detail.adults': 'adultos',
  'detail.child': 'niño',
  'detail.infant': 'bebé',
  'detail.priceBreakdown': 'Desglose del precio',
  'detail.subtotal': 'Subtotal',
  'detail.taxes': 'Impuestos',
  'detail.fees': 'Tarifas',
  'detail.discounts': 'Descuentos',
  'detail.surcharge': 'Recargo por tarjeta',
  'detail.grandTotal': 'Total general',
  'priceBreakdown.roomSubtotal': 'Subtotal de habitación',
  'priceBreakdown.total': 'Total',
  'detail.deposit': 'Depósito',
  'detail.depositDueBy': 'a pagar antes del',
  'detail.arrival': 'llegada',
  'detail.specialRequests': 'Solicitudes especiales',
  'detail.backToHome': 'Volver al inicio',
  'detail.confirmationSentTo': '__I18N_PENDING__:A confirmation email has been sent to',
  'detail.bookingReference': '__I18N_PENDING__:Booking reference',
  'detail.address': '__I18N_PENDING__:Address',
  'detail.guestDetails': '__I18N_PENDING__:Guest details',
  'detail.name': '__I18N_PENDING__:Name',
  'detail.email': '__I18N_PENDING__:Email',
  'detail.phone': '__I18N_PENDING__:Mobile number',
  'detail.status': '__I18N_PENDING__:Status',
  'detail.card': '__I18N_PENDING__:Card',
  'detail.paidInFull': '__I18N_PENDING__:Paid in full',
  'detail.partiallyPaid': '__I18N_PENDING__:Partially paid',
  'detail.paidOnline': '__I18N_PENDING__:Paid online',
  'detail.dueAtProperty': '__I18N_PENDING__:Due at property',
  'detail.bookedOn': '__I18N_PENDING__:Booked on',
  'detail.roomTotal': '__I18N_PENDING__:Room total',
  'detail.roomsCount': '__I18N_PENDING__:Rooms ({count})',
  'detail.yourRoom': '__I18N_PENDING__:Your room',
  'detail.roomNumber': '__I18N_PENDING__:Room {number}',
  'detail.priceSummary': '__I18N_PENDING__:Price summary',
  'detail.chargedInPropertyCurrency': '__I18N_PENDING__:Charged in property currency ({currency})',
  'detail.totalPaid': '__I18N_PENDING__:Total paid',
  'detail.plansChanged': '__I18N_PENDING__:Plans changed?',
  'detail.plansChangedBody':
    '__I18N_PENDING__:Contact the property directly, quoting your booking reference {reference}.',
  'detail.printConfirmation': '__I18N_PENDING__:Print confirmation',
  'detail.questions':
    '__I18N_PENDING__:Questions? Reply to your confirmation email or contact the property directly.',
  'shared.retry': 'Reintentar',
  'shared.close': 'Cerrar',
  'shared.back': 'Atrás',
  'shared.previous': 'Anterior',
  'shared.next': 'Siguiente',
  'validation.firstNameRequired': 'El nombre es obligatorio',
  'validation.lastNameRequired': 'El apellido es obligatorio',
  'validation.emailRequired': 'El correo electrónico es obligatorio',
  'validation.phoneRequired': 'El teléfono es obligatorio',
  'validation.addressRequired': 'La dirección es obligatoria',
  'validation.cityRequired': 'La ciudad es obligatoria',
  'validation.countryRequired': 'El país es obligatorio',
  'validation.postalCodeRequired': 'El código postal es obligatorio',
  'error.pmsUnavailable':
    'Lo sentimos, esta habitación ya no está disponible para las fechas seleccionadas. Vuelve atrás y elige otras fechas u otra habitación.',
  'error.pmsSyncError':
    'No pudimos conectarnos con el sistema del alojamiento. Inténtalo de nuevo en unos momentos.',
  'error.paymentNotConfigured':
    'El pago no está configurado para esta propiedad. Elige otra propiedad o ponte en contacto con atención al cliente.',
  'error.paymentStartFailed': 'Algo salió mal al iniciar el pago. Inténtalo de nuevo.',
  'error.bookingFailed': 'La reserva falló. Inténtalo de nuevo.',
  'error.quoteAlreadyConverted':
    '__I18N_PENDING__:This rate has already been booked. Please select the room and rate again.',
  'error.quoteRequiresMember':
    '__I18N_PENDING__:A selected rate is a member rate. Sign in to keep it, or remove the room and pick it again.',
  'site.title.default': 'Reserva tu estancia',
  'site.title.suffix': 'Apartamentos y hoteles',
  'site.title.home': 'Inicio',
  'site.title.search': 'Búsqueda',
  'site.title.property': 'Propiedad',
  'site.title.room': 'Habitación',
  'site.title.guestDetails': 'Datos del huésped',
  'site.title.payment': 'Pago',
  'site.title.confirmation': 'Reserva confirmada',
  'site.title.bookingLookup': 'Buscar tu reserva',
  'site.title.bookingDetails': 'Detalles de la reserva',
  'site.title.cancellation': 'Cancelar reserva',
  'site.title.reservationDetail': 'Detalles de la reserva',
  'site.title.signIn': 'Iniciar sesión',
  'site.title.signUp': 'Crear cuenta',
  'site.title.notFound': 'Página no encontrada',
  'notFound.title': 'Página no encontrada',
  'notFound.message': 'La página que buscas no existe.',
  'notFound.backHome': 'Volver al inicio',
  'home.heroAlt': 'Panorama urbano de Australia',
  'home.featuredProperties': 'Propiedades destacadas',
  'home.popularDestinations': 'Destinos populares',
  'common.reviews': '{count} valoraciones',
  'common.reviews_one': '{count} valoración',
  'common.reviews_other': '{count} valoraciones',
  'common.loading': 'Cargando',
  'common.pleaseWait': '__I18N_PENDING__:Please wait while we load your results',
  'common.of': 'de',
  'common.select': 'Seleccionar…',
  'common.search': 'Buscar…',
  'common.selectLocation': 'Selecciona una ubicación',
  'location.propertyCount': '__I18N_PENDING__:{count} properties',
  'location.propertyCount_one': '__I18N_PENDING__:{count} property',
  'location.propertyCount_other': '__I18N_PENDING__:{count} properties',
  'location.roomsAvailable': '__I18N_PENDING__:{count} rooms available',
  'location.roomsAvailable_one': '__I18N_PENDING__:{count} room available',
  'location.roomsAvailable_other': '__I18N_PENDING__:{count} rooms available',
  'map.suburb.newstead': '__I18N_PENDING__:Newstead',
  'map.suburb.fortitudeValley': '__I18N_PENDING__:Fortitude Valley',
  'map.suburb.paddington': '__I18N_PENDING__:Paddington',
  'map.suburb.bardon': '__I18N_PENDING__:Bardon',
  'map.suburb.brisbane': '__I18N_PENDING__:Brisbane',
  'map.suburb.southBrisbane': '__I18N_PENDING__:South Brisbane',
  'map.suburb.kangarooPoint': '__I18N_PENDING__:Kangaroo Point',
  'map.suburb.stLucia': '__I18N_PENDING__:St Lucia',
  'map.suburb.moorooka': '__I18N_PENDING__:Moorooka',
  'map.suburb.annerley': '__I18N_PENDING__:Annerley',
  'map.suburb.mtGravatt': '__I18N_PENDING__:Mt Gravatt',
  'common.noOptions': 'No hay opciones disponibles',
  'common.code': 'Código',
  'common.searchCode': 'Buscar código…',
  'filter.title': 'Filtros',
  'filter.price': 'Precio',
  'filter.priceMinimum': 'Mínimo',
  'filter.priceMaximum': 'Máximo',
  'filter.priceMinPlaceholder': '$0',
  'filter.priceMaxPlaceholder': '$500+',
  'filter.propertyType': 'Tipo de propiedad',
  'filter.propertyType.hotel': 'Hotel',
  'filter.propertyType.apartment': 'Apartamento',
  'filter.propertyType.resort': 'Resort',
  'filter.amenities': 'Servicios',
  'filter.amenity.pool': 'Piscina',
  'filter.amenity.parking': 'Estacionamiento',
  'filter.amenity.breakfast': 'Desayuno incluido',
  'filter.rating': 'Valoración',
  'filter.rating.any': 'Cualquier valoración',
  'filter.rating.5': '5 estrellas',
  'filter.rating.4': '4 estrellas o más',
  'filter.rating.3': '3 estrellas o más',
  'filter.more': 'Más',
  'filter.more.freeCancellation': 'Cancelación gratuita',
  'filter.more.payAtProperty': 'Pagar en el alojamiento',
  'filter.clear': 'Borrar',
  'filter.apply': 'Aplicar filtros',
  'card.reviews_one': 'valoración',
  'card.reviews_other': 'valoraciones',
  'card.imageCounter': '{current} / {total}',
  'card.showMore': '__I18N_PENDING__:show more',
  'card.showLess': '__I18N_PENDING__:show less',
  'widget.childrenAgeHint': 'Edades 0 - 12',
  'auth.orContinueWith': 'O continuar con',
  'auth.signIn.title': 'Inicia sesión en tu cuenta',
  'auth.signIn.subtitle':
    '¡Bienvenido de nuevo! Inicia sesión para gestionar tus reservas, ver tus estancias y acceder a ofertas exclusivas.',
  'auth.email': 'Correo electrónico',
  'auth.emailPlaceholder': 'Ingresa tu correo electrónico',
  'auth.emailRequired': 'El correo electrónico es obligatorio.',
  'auth.emailInvalid': 'Por favor, ingresa un correo electrónico válido.',
  'auth.password': 'Contraseña',
  'auth.passwordPlaceholder': 'Ingresa tu contraseña',
  'auth.createPasswordPlaceholder': 'Crea una contraseña',
  'auth.passwordRequired': 'La contraseña es obligatoria.',
  'auth.passwordMinLength': 'La contraseña debe tener al menos {min} caracteres.',
  'auth.passwordPattern': 'La contraseña debe incluir letras y números.',
  'auth.passwordHint':
    'Usa al menos {min} caracteres con una combinación de letras, números y símbolos.',
  'auth.showPassword': 'Mostrar contraseña',
  'auth.hidePassword': 'Ocultar contraseña',
  'auth.keepSignedIn': 'Mantenerme conectado',
  'auth.forgotPassword': '¿Olvidaste tu contraseña?',
  'auth.forgot.title': '__I18N_PENDING__:Reset your password',
  'auth.forgot.subtitle':
    '__I18N_PENDING__:Enter the email address on your account and we will send you a link to choose a new password.',
  'auth.forgot.submit': '__I18N_PENDING__:Send reset link',
  'auth.forgot.sending': '__I18N_PENDING__:Sending...',
  'auth.forgot.success':
    '__I18N_PENDING__:If an account exists for that email, a reset link is on its way. Check your inbox and spam folder.',
  'auth.forgot.backToSignIn': '__I18N_PENDING__:Back to sign in',
  'auth.reset.title': '__I18N_PENDING__:Choose a new password',
  'auth.reset.subtitle': '__I18N_PENDING__:Enter a new password for your account.',
  'auth.reset.submit': '__I18N_PENDING__:Reset password',
  'auth.reset.saving': '__I18N_PENDING__:Resetting...',
  'auth.reset.success':
    '__I18N_PENDING__:Your password has been updated. You can sign in with it now.',
  'auth.reset.missingToken':
    '__I18N_PENDING__:This reset link is missing its token. Request a new link instead.',
  'auth.reset.goToSignIn': '__I18N_PENDING__:Go to sign in',
  'auth.verify.title': '__I18N_PENDING__:Verify your email',
  'auth.verify.verifying': '__I18N_PENDING__:Verifying your email address…',
  'auth.verify.success':
    '__I18N_PENDING__:Your email address has been verified. You can sign in now.',
  'auth.verify.error': '__I18N_PENDING__:We could not verify this link.',
  'auth.verify.missingToken':
    '__I18N_PENDING__:This verification link is missing its token. Sign in to request a new link.',
  'auth.verify.errorHint':
    '__I18N_PENDING__:The link may have expired. Sign in to request a new verification email.',
  'auth.verify.goToSignIn': '__I18N_PENDING__:Go to sign in',
  'auth.verify.resend': '__I18N_PENDING__:Resend verification email',
  'auth.verify.sending': '__I18N_PENDING__:Sending email…',
  'auth.verify.resent':
    '__I18N_PENDING__:Verification email sent. Please check your inbox and spam folder.',
  'auth.signIn': 'Iniciar sesión',
  'auth.signingIn': 'Iniciando sesión...',
  'auth.signInError': 'Error al iniciar sesión. Inténtalo de nuevo.',
  'auth.googleError': 'Error al iniciar sesión con Google.',
  'auth.noAccount': '¿No tienes una cuenta?',
  'auth.createAccount': 'Crear una cuenta',
  'auth.signUp.title': 'Crea tu cuenta',
  'auth.signUp.subtitle':
    'Únete a {site} para gestionar tus reservas, guardar tus propiedades favoritas y obtener ofertas exclusivas.',
  'auth.firstName': 'Nombre',
  'auth.firstNamePlaceholder': 'Ingresa tu nombre',
  'auth.firstNameRequired': 'El nombre es obligatorio.',
  'auth.lastName': 'Apellido',
  'auth.lastNamePlaceholder': 'Ingresa tu apellido',
  'auth.lastNameRequired': 'El apellido es obligatorio.',
  'auth.mobile': 'Teléfono móvil',
  'auth.mobilePlaceholder': 'Ingresa tu teléfono móvil',
  'auth.dialingCode': 'Prefijo internacional',
  'auth.mobileRequired': 'El teléfono móvil es obligatorio.',
  'auth.mobileInvalid': 'Por favor, ingresa un número de teléfono móvil válido.',
  'auth.confirmPassword': 'Confirmar contraseña',
  'auth.confirmPasswordPlaceholder': 'Confirma tu contraseña',
  'auth.termsAgree': 'Acepto los',
  'auth.termsRequired': 'Debes aceptar los Términos y condiciones y la Política de privacidad.',
  'auth.marketingConsent':
    'Me gustaría recibir ofertas exclusivas e inspiración para viajar de {site}',
  'auth.signUpError': 'No se pudo crear la cuenta. Inténtalo de nuevo.',
  'auth.signUp': 'Registrarse',
  'auth.creatingAccount': 'Creando cuenta...',
  'auth.createAccountButton': 'Crear cuenta',
  'auth.alreadyHaveAccount': '¿Ya tienes una cuenta?',
  'auth.passwordMismatch': 'Las contraseñas no coinciden.',
  'pricing.title': 'Resumen de precios',
  'pricing.noRoomsSelected':
    'No se han seleccionado habitaciones. Vuelve atrás y selecciona habitaciones.',
  'pricing.backToAvailability': 'Volver a disponibilidad',
  'pricing.continue': 'Continuar con los datos del huésped',
  'property.youSavePercent': 'Ahorras ({percent}% de descuento)',
  'property.includingTaxesFees': '(impuestos y tarifas incluidos)',
  'map.zoomIn': 'Acercar',
  'map.zoomOut': 'Alejar',
  'map.viewFullMap': 'Ver en mapa completo',
  'booking.progress': 'Progreso de la reserva',
  'reservationDetail.resetAria': 'Restablecer estado de la reserva',
  'bookingLookup.title': 'Buscar tu reserva',
  'bookingLookup.description':
    'Ingresa tu referencia de reserva y correo electrónico para ver, modificar o cancelar tu reserva.',
  'bookingLookup.bookingReference': 'Referencia de reserva',
  'bookingLookup.placeholder': 'p. ej. SYD-260815-0001',
  'bookingLookup.lookingUp': 'Buscando…',
  'bookingLookup.findBooking': 'Buscar reserva',
  'bookingLookup.notFound':
    'Reserva no encontrada. Prueba BK-2026-001, alex.morgan@example.com y Morgan.',
  'cancellation.title': 'Cancelar reserva',
  'cancellation.property': 'Propiedad',
  'cancellation.details': 'Detalles de la cancelación',
  'cancellation.penalty': 'Penalización por cancelación',
  'cancellation.refund': 'Importe del reembolso',
  'cancellation.totalPaid': 'Total pagado:',
  'cancellation.reasonLabel': 'Motivo de la cancelación (opcional)',
  'cancellation.understand': 'Entiendo que esta acción no se puede deshacer.',
  'cancellation.cancelledDemo':
    'Tu reserva ha sido cancelada en esta demostración de la interfaz. Importe del reembolso: {{refundAmount}}.',
  'cancellation.confirm': 'Confirmar cancelación',
  'cancellation.notFound': 'Reserva no encontrada.',
  'bookingDetails.title': 'Detalles de la reserva',
  'bookingDetails.notFound': 'Reserva no encontrada.',
  'bookingDetails.checkIn': 'Entrada:',
  'bookingDetails.checkOut': 'Salida:',
  'bookingDetails.rooms': 'Habitaciones',
  'bookingDetails.guest': 'Huésped',
  'bookingDetails.freeCancellationUntil': 'Cancelación gratuita hasta {date}',
  'bookingDetails.total': 'Total:',
  'reservationDetail.loading': 'Cargando tu reserva…',
  'reservationDetail.noReference': 'No se proporcionó ninguna referencia de reserva.',
  'reservationDetail.loadError': 'No se pudieron cargar los detalles de la reserva.',
  'site.footer.brand': 'BookYourStay',
  'common.loadingLocations': 'Cargando ubicaciones…',
  'common.couldNotLoadLocations': 'No se pudieron cargar las ubicaciones',
  'common.searchLocationPlaceholder': 'Buscar país, ciudad o propiedad',
  'common.collapse': 'Colapsar',
  'common.expand': 'Expandir',
  'map.loadingGoogle': 'Cargando Google Map…',
  'map.errorGoogle': 'No se pudo cargar Google Maps',
  'map.errorMap': 'No se pudo cargar el mapa.',
  'map.greatLocation': 'Excelente ubicación',
  'home.trust.secureBooking': 'Reserva segura',
  'home.trust.secureBookingDesc': 'Tu información está segura con nosotros.',
  'home.trust.bestPrice': 'Mejor precio garantizado',
  'home.trust.bestPriceDesc': '¿Encontraste un precio más bajo? Lo igualamos.',
  'home.trust.localSupport': 'Atención 24/7',
  'home.trust.localSupportDesc': 'Estamos aquí para ayudarte cuando lo necesites.',
  'home.trust.flexibleBooking': 'Opciones flexibles',
  'home.trust.flexibleBookingDesc': 'Cancelación gratuita en tarifas seleccionadas.',
  'promotion.memberPromo': 'Promoción de socio',
  'promotion.save': 'Ahorra',
  'property.memberRate': 'Tarifa de socio',
  'property.hideAmenities': 'Ocultar servicios',
  'property.showAllAmenities': 'Mostrar todos los servicios',
  'property.chooseRatePromo':
    'Elige tu tarifa preferida: las tarifas de socio ofrecen ahorros exclusivos.',
  'roomRate.stepChooseStay': '__I18N_PENDING__:Choose your stay',
  'roomRate.stepCheckout': '__I18N_PENDING__:Checkout',
  'roomRate.stepConfirmation': '__I18N_PENDING__:Confirmation',
  'roomRate.membersSaveUpTo': '__I18N_PENDING__:Members save up to {percent}%',
  'roomRate.membersSaveMore': '__I18N_PENDING__:Members save more',
  'roomRate.memberSignInHint':
    '__I18N_PENDING__:Sign in or join free during checkout to unlock member rates.',
  'roomRate.from': '__I18N_PENDING__:FROM',
  'roomRate.perNightSuffix': '__I18N_PENDING__:/ night',
  'roomRate.nonMemberFrom': '__I18N_PENDING__:Non-member rate from {price}',
  'roomRate.taxesIncluded': '__I18N_PENDING__:Rates include taxes & fees',
  'roomRate.taxesExcluded': '__I18N_PENDING__:Rates exclude taxes & fees',
  'roomRate.inclTaxes': '__I18N_PENDING__:incl. taxes & fees',
  'roomRate.exclTaxes': '__I18N_PENDING__:excl. taxes & fees',
  'roomRate.includesTaxes': '__I18N_PENDING__:Includes taxes and fees',
  'roomRate.excludesTaxes': '__I18N_PENDING__:Excludes taxes and fees',
  'roomRate.bookNow': '__I18N_PENDING__:Book now',
  'roomRate.selectRate': '__I18N_PENDING__:Select this rate',
  'roomRate.bestValue': '__I18N_PENDING__:Best Value',
  'roomRate.onlyLeftAtPrice': '__I18N_PENDING__:Only {count} left at this price',
  'roomRate.fullDetails': '__I18N_PENDING__:Full room details',
  'roomRate.loadMoreRates': '__I18N_PENDING__:Load more rates',
  'roomRate.showLessRates': '__I18N_PENDING__:Show less rates',
  'roomRate.vsNonMemberTotal': '__I18N_PENDING__:vs non-member total of {total}',
  'roomRate.youSave': '__I18N_PENDING__:You save {amount} ({percent}% off)',
  'roomRate.totalForNights': '__I18N_PENDING__:{total} total • {nights} nights',
  'roomRate.nightTimes': '__I18N_PENDING__:{nights} nights × {perNight}',
  'roomRate.totalLine': '__I18N_PENDING__:{total} total • {taxNote}',
  'roomRate.notMemberYet':
    '__I18N_PENDING__:Not a member yet? Join during checkout — the member price still applies.',
  'roomRate.promoApplied': '__I18N_PENDING__:Promo {code} applied',
  'roomRate.promotions': '__I18N_PENDING__:Promotions',
  'roomRate.promoSaveSuffix': '__I18N_PENDING__:Save - {percent}%',
  'roomRate.promoSaveAmountSuffix': '__I18N_PENDING__:Save - {amount}',
  'roomRate.promoStayPaySuffix': '__I18N_PENDING__:Stay {stayNights} nights, pay for {payNights}',
  'roomRate.promoEarlyBirdSuffix': '__I18N_PENDING__:Save - {percent}% when booked early',
  'roomRate.promoLastMinuteSuffix': '__I18N_PENDING__:Save - {percent}% for last-minute stays',
  'roomRate.promoLongStaySuffix': '__I18N_PENDING__:Save - {percent}% on longer stays',
  'roomRate.promoFixedRateSuffix': '__I18N_PENDING__:Special rate — {rate} per night',
  'roomRate.memberLocked': '__I18N_PENDING__:Member-only promotion',
  'roomRate.memberUnlockTitle': '__I18N_PENDING__:Sign in or join to unlock',
  'roomRate.memberUnlockSaving': '__I18N_PENDING__:member rates and save {amount} ({percent}%)',
  'roomRate.memberRateIncludes': '__I18N_PENDING__:Member rate includes',
  'roomRate.memberBenefitRatesTitle': '__I18N_PENDING__:Up to {percent}% lower rates',
  'roomRate.memberBenefitRatesBody':
    '__I18N_PENDING__:Unlock member-only promotions like {promotions}.',
  'roomRate.memberBenefitRatesBodyGeneric': '__I18N_PENDING__:Unlock member-only promotions.',
  'roomRate.memberBenefitBenefitsTitle': '__I18N_PENDING__:Same great benefits',
  'roomRate.memberBenefitBenefitsBody':
    '__I18N_PENDING__:Free cancellation, flexible payment and all standard inclusions.',
  'roomRate.memberBenefitJoinTitle': '__I18N_PENDING__:Free to join',
  'roomRate.memberBenefitJoinBody':
    '__I18N_PENDING__:Create an account in seconds during checkout.',
  'roomRate.joinFree': '__I18N_PENDING__:Join free',
  'roomRate.joinFreeCta': '__I18N_PENDING__:Sign in or join free',
  'roomRate.alreadyMember': '__I18N_PENDING__:Already a member?',
  'roomRate.alreadyMemberHint': '__I18N_PENDING__:Sign in to see your member rates applied',
  'roomRate.viewOtherRooms': '__I18N_PENDING__:View other room types',
  'roomRate.view': '__I18N_PENDING__:View',
  'roomRate.freeCancelUntil': '__I18N_PENDING__:Free cancellation until {date}',
  'roomRate.upsell': '__I18N_PENDING__:Recommended alternative',
  'roomRate.roomsIncluded': '__I18N_PENDING__:{count} rooms included',
  'roomRate.nightlyBreakdown': '__I18N_PENDING__:Night-by-night price',
  'roomRate.previousRate': '__I18N_PENDING__:Previous rate',
  'roomRate.nextRate': '__I18N_PENDING__:Next rate',
  'card.discount': '-{percent}% de descuento',
  'gallery.imageAlt': '{title} - vista {current} de {total}',
  'gallery.thumbnailAlt': 'Ir a la vista {current} de {total}',
  'gallery.previewAlt': 'Vista previa de {title}',
  'detail.night_one': 'noche',
  'detail.night_other': 'noches',
  'detail.adult_one': 'adulto',
  'detail.adult_other': 'adultos',
  'detail.child_one': 'niño',
  'detail.child_other': 'niños',
  'detail.infant_one': 'bebé',
  'detail.infant_other': 'bebés',
} as const;
